var $ = window.jQuery;
var SELECTOR = '#acord-calculator';

var container = null;
var intro = null;
var beginSurvey = null;
var survey = null;
var goNext = null;
var goBack = null;
var submit = null;
var bubs = null;
var pages = null;
var pageNumber = null;
var progressBar = null;
var formNav = null;

var currentPage = false;
var totalPages = 0;

function onDocumentReady() {
	container = $(SELECTOR);

	if (container.length > 0) {
		intro = $('.intro', container);
		beginSurvey = $('.cta.begin-survey', container);
		survey = $('.survey', container);
		goNext = $('.cta.go-next', container);
		goBack = $('.cta.go-back', container);
		submit = $('.cta.complete-survey', container);
		bubs = $('.mr-bubs', container);
		pageNumber = $('.progress-bar .current', container);
		pages = $('.gfield');
		progressBar = $('.progress-bar', container);
		formNav = $('.form-nav', container);

		totalPages = pages.length;

		initialize();
	}
}

function initialize() {
	beginSurvey.on('click', onClickBeginSurvey);
	goNext.on('click', onClickGoNext);
	goBack.on('click', onClickGoBack);
	submit.on('click', onClickSubmit);
	survey.on('change', onFormChange);
	survey.on('keyup', onFormChange);
	survey.on('submit', onFormSubmit);
}

function onClickGoNext(e) {
	let p = 1;
	if (currentPage) {
		p = currentPage.index() + 1;
	}

	disableButton(goNext);
	goToPage(p + 1);

	e.preventDefault();
	return false;
}

function onClickGoBack(e) {
	let p = 1;
	if (currentPage) {
		p = currentPage.index() + 1;
	}

	goToPage(p - 1);

	e.preventDefault();
	return false;
}

function onClickSubmit() {
	let form = $('form', container);
	form.submit();
}

function onFormSubmit() {
	let form = $('form', container);

	let wrap = form.closest('.form-wrapper');
	wrap.addClass('posting');
	progressBar.slideUp();
	formNav.slideUp();

	$(document).on('gform_confirmation_loaded', function() {
		wrap.removeClass('posting');

		let grade = wrap.find('.acord-calculator-confirmation').attr('data-grade');
		let wdtm = $('#what-does-this-mean');

		wdtm.find(`[data-grade="${grade}"]`).show();
		wdtm.slideDown();
	});
}

function onClickBeginSurvey() {
	intro.slideUp();
	survey.slideDown(400, () => {
		setTimeout(function() {
			goToPage(1);
		}, 100);
	});
}

function disableButton(button) {
	return $(button).addClass('disabled').attr('disabled', 'disabled');
}

function enableButton(button) {
	return $(button).removeClass('disabled').removeAttr('disabled');
}

function goToPage(n) {
	let index = parseInt(Math.max(0, n - 1), 10);
	let progress = n / totalPages;
	let destinationPage = pages.eq(index);

	bubs.find('.fill').css('transform', `scaleX(${progress})`);

	if (index === 0) {
		disableButton(goBack);
	} else {
		enableButton(goBack);
	}

	if (n === totalPages) {
		goNext.hide();
		submit.show();
	} else {
		goNext.show();
		submit.hide();
	}


	if (currentPage) {
		currentPage.slideUp(400, () => {
			destinationPage.slideDown(400, onFormChange);
		});
	} else {
		destinationPage.slideDown(400, onFormChange);
	}

	pageNumber.text(n);
	currentPage = destinationPage;
}

function onFormChange(e) {
	let b = goNext;
	if (submit.is(':visible')) {
		b = submit;
	}
	let pageIsComplete = false;
	if (currentPage.find('.ginput_container_number').length > 0) {
		var val = parseFloat(currentPage.find('input').val().replace(/^\$/, ''));
		pageIsComplete = (val > 0);
	} else {
		pageIsComplete = currentPage.find(':checked').length > 0;
	}

	if (pageIsComplete) {
		enableButton(b);
	} else {
		disableButton(b);
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
